import { lazy } from 'react'
import { withSuspense, withVinProviders } from 'utils/lazyLoad/lazyWrapper'

const Home = lazy(() => import('features/seller/pages/Home'))
const Vehicle = lazy(() => import('features/seller/pages/Vehicle'))
const ViewVehicle = lazy(
  () => import('features/seller/pages/Vehicle/actions/View'),
)

const VinDecoder = lazy(
  () => import('features/seller/pages/Vehicle/actions/VinDecoder'),
)
const Scan = lazy(() => import('features/seller/pages/Vehicle/actions/Scan'))

const AddVehicle = lazy(
  () => import('features/seller/pages/Vehicle/actions/Add'),
)
const EditVehicle = lazy(
  () => import('features/seller/pages/Vehicle/actions/Edit'),
)

const ParkingLot = lazy(() => import('features/seller/pages/ParkingLot'))
const LaunchParkingLot = lazy(
  () => import('features/seller/pages/ParkingLot/actions/Launch'),
)
const BulkLaunch = lazy(
  () => import('features/seller/pages/ParkingLot/actions/BulkLaunch'),
)

const Live = lazy(() => import('features/seller/pages/Live'))
const ViewLive = lazy(() => import('features/seller/pages/Live/actions/View'))

const BuyItNowPage = lazy(() => import('features/seller/pages/Buy-it-now'))
const ViewBuyItNow = lazy(
  () => import('features/seller/pages/Buy-it-now/actions/View'),
)

const Scheduled = lazy(() => import('features/seller/pages/Scheduled'))
const EditScheduled = lazy(
  () => import('features/seller/pages/Scheduled/actions/Edit'),
)

const Pending = lazy(() => import('features/seller/pages/Pending'))
const ViewPending = lazy(
  () => import('features/seller/pages/Pending/actions/View'),
)

const Closed = lazy(() => import('features/seller/pages/Closed'))
const ViewClosed = lazy(
  () => import('features/seller/pages/Closed/actions/View'),
)

const Sold = lazy(() => import('features/seller/pages/Sold'))
const ViewSold = lazy(() => import('features/seller/pages/Sold/actions/View'))

const SalesHistory = lazy(() => import('features/seller/pages/SalesHistory'))

const ViewProfile = lazy(
  () => import('features/profile/components/ViewProfile'),
)
const EditProfile = lazy(
  () => import('features/profile/components/EditProfile'),
)
const ChangePassword = lazy(
  () => import('features/profile/components/ChangePassword'),
)

const Announcement = lazy(
  () => import('features/notifications/components/Announcement'),
)
const Notification = lazy(
  () => import('features/notifications/components/Notification'),
)

const Buyerprofile = lazy(() => import('features/seller/pages/BuyerProfile'))
const Document = lazy(
  () => import('features/invoices/components/BillOfSale/Document'),
)
const SellerLogs = lazy(
  () => import('features/seller/pages/logs/SellerLogs.js'),
)

export const SellerRoutes = [
  { path: '/', element: withSuspense(Home) },

  { path: '/vehicle', element: withSuspense(Vehicle) },
  { path: '/vehicle/:id', element: withSuspense(ViewVehicle) },

  { path: '/vehicle/add', element: withSuspense(AddVehicle) },
  { path: '/vehicle/edit/:id', element: withSuspense(EditVehicle) },

  { path: '/vin/decoder', element: withVinProviders(VinDecoder) },
  { path: '/vin/decoder/scan', element: withVinProviders(Scan) },

  { path: '/parking-lot', element: withSuspense(ParkingLot) },
  { path: '/parking-lot/:id', element: withSuspense(LaunchParkingLot) },
  { path: '/parking-lot-bulk/:ids', element: withSuspense(BulkLaunch) },

  { path: '/live', element: withSuspense(Live) },
  { path: '/live/:id', element: withSuspense(ViewLive) },

  { path: '/launch_to_buy_it_now', element: withSuspense(BuyItNowPage) },
  { path: '/buy-it-now/:id', element: withSuspense(ViewBuyItNow) },

  { path: '/scheduled', element: withSuspense(Scheduled) },
  { path: '/scheduled/edit/:id', element: withSuspense(EditScheduled) },

  { path: '/pending', element: withSuspense(Pending) },
  { path: '/pending/:id', element: withSuspense(ViewPending) },

  { path: '/closed', element: withSuspense(Closed) },
  { path: '/closed/:id', element: withSuspense(ViewClosed) },

  { path: '/sold', element: withSuspense(Sold) },
  { path: '/sold/:id', element: withSuspense(ViewSold) },

  { path: '/document/:id', element: withSuspense(Document) },

  { path: '/sales-history', element: withSuspense(SalesHistory) },

  { path: '/profile', element: withSuspense(ViewProfile) },
  { path: '/edit-profile', element: withSuspense(EditProfile) },
  { path: '/change-password', element: withSuspense(ChangePassword) },

  { path: '/announcement/:id', element: withSuspense(Announcement) },
  { path: '/notifications', element: withSuspense(Notification) },

  { path: '/buyer/profile/:id', element: withSuspense(Buyerprofile) },
  { path: '/user-logs', element: withSuspense(SellerLogs) },
]
